{
    "v": "4.8.0",
    "meta": { "g": "LottieFiles AE ", "a": "", "k": "", "d": "", "tc": "" },
    "fr": 25,
    "ip": 0,
    "op": 50,
    "w": 500,
    "h": 500,
    "nm": "40- Message",
    "ddd": 0,
    "assets": [
        {
            "id": "comp_0",
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 4,
                    "nm": "Arrow 2",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": 0.52, "y": 1 },
                                    "o": { "x": 0.48, "y": 0 },
                                    "t": 26,
                                    "s": [-152.28, 354.436, 0],
                                    "to": [68.333, 0, 0],
                                    "ti": [-68.333, 0, 0]
                                },
                                { "t": 42, "s": [257.72, 354.436, 0] }
                            ],
                            "ix": 2
                        },
                        "a": { "a": 0, "k": [7.72, 104.436, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-5.249, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-2.406, 1.85],
                                                [0, 0],
                                                [3.548, 2.797],
                                                [0, 0],
                                                [0, -2.53],
                                                [0, 0],
                                                [0, 0],
                                                [0.023, -4.963],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0],
                                                [0, 3.035],
                                                [0, 0],
                                                [3.582, -2.754],
                                                [0, 0],
                                                [-1.987, -1.567],
                                                [0, 0],
                                                [0, 0],
                                                [-4.963, 0],
                                                [0, 0],
                                                [-0.024, 5.249]
                                            ],
                                            "v": [
                                                [-90.613, 139.036],
                                                [12.987, 139.036],
                                                [12.987, 180.919],
                                                [18.876, 183.82],
                                                [112.818, 111.59],
                                                [112.884, 100.649],
                                                [16.855, 24.943],
                                                [11.949, 27.322],
                                                [11.949, 67.486],
                                                [-90.825, 67.486],
                                                [-99.84, 76.459],
                                                [-100.086, 129.52]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.157, 0.176, 0.212, 1],
                                        "ix": 3
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 24, "ix": 5 },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 12,
                    "op": 50,
                    "st": 12,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 4,
                    "nm": "Arrow",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": 0.52, "y": 1 },
                                    "o": { "x": 0.48, "y": 0 },
                                    "t": 1,
                                    "s": [257.72, 354.436, 0],
                                    "to": [-15, 0, 0],
                                    "ti": [-66.333, 0, 0]
                                },
                                {
                                    "i": { "x": 0.52, "y": 1 },
                                    "o": { "x": 0.48, "y": 0 },
                                    "t": 14,
                                    "s": [167.72, 354.436, 0],
                                    "to": [66.333, 0, 0],
                                    "ti": [-81.333, 0, 0]
                                },
                                { "t": 29, "s": [655.72, 354.436, 0] }
                            ],
                            "ix": 2
                        },
                        "a": { "a": 0, "k": [7.72, 104.436, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-5.249, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-2.406, 1.85],
                                                [0, 0],
                                                [3.548, 2.797],
                                                [0, 0],
                                                [0, -2.53],
                                                [0, 0],
                                                [0, 0],
                                                [0.023, -4.963],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0],
                                                [0, 3.035],
                                                [0, 0],
                                                [3.582, -2.754],
                                                [0, 0],
                                                [-1.987, -1.567],
                                                [0, 0],
                                                [0, 0],
                                                [-4.963, 0],
                                                [0, 0],
                                                [-0.024, 5.249]
                                            ],
                                            "v": [
                                                [-90.613, 139.036],
                                                [12.987, 139.036],
                                                [12.987, 180.919],
                                                [18.876, 183.82],
                                                [112.818, 111.59],
                                                [112.884, 100.649],
                                                [16.855, 24.943],
                                                [11.949, 27.322],
                                                [11.949, 67.486],
                                                [-90.825, 67.486],
                                                [-99.84, 76.459],
                                                [-100.086, 129.52]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.157, 0.176, 0.212, 1],
                                        "ix": 3
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 24, "ix": 5 },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 50,
                    "st": 0,
                    "bm": 0
                }
            ]
        },
        {
            "id": "comp_1",
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 4,
                    "nm": "Arrow 4",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": 0.52, "y": 1 },
                                    "o": { "x": 0.48, "y": 0 },
                                    "t": 1,
                                    "s": [257.72, 354.436, 0],
                                    "to": [-15, 0, 0],
                                    "ti": [-66.333, 0, 0]
                                },
                                {
                                    "i": { "x": 0.52, "y": 1 },
                                    "o": { "x": 0.48, "y": 0 },
                                    "t": 14,
                                    "s": [167.72, 354.436, 0],
                                    "to": [66.333, 0, 0],
                                    "ti": [-81.333, 0, 0]
                                },
                                { "t": 29, "s": [655.72, 354.436, 0] }
                            ],
                            "ix": 2
                        },
                        "a": { "a": 0, "k": [7.72, 104.436, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-5.249, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-2.406, 1.85],
                                                [0, 0],
                                                [3.548, 2.797],
                                                [0, 0],
                                                [0, -2.53],
                                                [0, 0],
                                                [0, 0],
                                                [0.023, -4.963],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0],
                                                [0, 3.035],
                                                [0, 0],
                                                [3.582, -2.754],
                                                [0, 0],
                                                [-1.987, -1.567],
                                                [0, 0],
                                                [0, 0],
                                                [-4.963, 0],
                                                [0, 0],
                                                [-0.024, 5.249]
                                            ],
                                            "v": [
                                                [-90.613, 139.036],
                                                [12.987, 139.036],
                                                [12.987, 180.919],
                                                [18.876, 183.82],
                                                [112.818, 111.59],
                                                [112.884, 100.649],
                                                [16.855, 24.943],
                                                [11.949, 27.322],
                                                [11.949, 67.486],
                                                [-90.825, 67.486],
                                                [-99.84, 76.459],
                                                [-100.086, 129.52]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.157, 0.176, 0.212, 1],
                                        "ix": 3
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 50,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 4,
                    "nm": "Arrow 3",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": 0.52, "y": 1 },
                                    "o": { "x": 0.48, "y": 0 },
                                    "t": 26,
                                    "s": [-152.28, 354.436, 0],
                                    "to": [68.333, 0, 0],
                                    "ti": [-68.333, 0, 0]
                                },
                                { "t": 42, "s": [257.72, 354.436, 0] }
                            ],
                            "ix": 2
                        },
                        "a": { "a": 0, "k": [7.72, 104.436, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-5.249, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-2.406, 1.85],
                                                [0, 0],
                                                [3.548, 2.797],
                                                [0, 0],
                                                [0, -2.53],
                                                [0, 0],
                                                [0, 0],
                                                [0.023, -4.963],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0],
                                                [0, 3.035],
                                                [0, 0],
                                                [3.582, -2.754],
                                                [0, 0],
                                                [-1.987, -1.567],
                                                [0, 0],
                                                [0, 0],
                                                [-4.963, 0],
                                                [0, 0],
                                                [-0.024, 5.249]
                                            ],
                                            "v": [
                                                [-90.613, 139.036],
                                                [12.987, 139.036],
                                                [12.987, 180.919],
                                                [18.876, 183.82],
                                                [112.818, 111.59],
                                                [112.884, 100.649],
                                                [16.855, 24.943],
                                                [11.949, 27.322],
                                                [11.949, 67.486],
                                                [-90.825, 67.486],
                                                [-99.84, 76.459],
                                                [-100.086, 129.52]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.157, 0.176, 0.212, 1],
                                        "ix": 3
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        }
                    ],
                    "ip": 12,
                    "op": 50,
                    "st": 12,
                    "bm": 0
                }
            ]
        },
        {
            "id": "comp_2",
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 4,
                    "nm": "Mail top 2",
                    "parent": 6,
                    "td": 1,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-0.001, -138.232, 0], "ix": 2 },
                        "a": { "a": 0, "k": [-0.001, -138.232, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.48, "y": 0 },
                                                "t": 2,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-12.426, 9.482],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.426, 9.482],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-21.043, -25.544],
                                                            [21.043, -25.544],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 10,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-17.7, -11.455],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.805, -8.721],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-20.429, -249.544],
                                                            [21.656, -250.294],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.52, "y": 1 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 25,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-17.7, -11.455],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.805, -8.721],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-20.429, -249.544],
                                                            [21.656, -250.294],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 35,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-12.426, 9.482],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.426, 9.482],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-21.043, -25.544],
                                                            [21.043, -25.544],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 50,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 4,
                    "nm": "Mail lines",
                    "parent": 6,
                    "tt": 2,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-63, -85],
                                                [70, -85]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 2",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-130.5, -110],
                                                [132.5, -110]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-168.713, -138.232],
                                                [-26.79, -29.93]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [26.79, -29.93],
                                                [168.712, -138.231]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 50,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 3,
                    "ty": 4,
                    "nm": "Mail top",
                    "parent": 6,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-0.001, -138.232, 0], "ix": 2 },
                        "a": { "a": 0, "k": [-0.001, -138.232, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.48, "y": 0 },
                                                "t": 2,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-12.426, 9.482],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.426, 9.482],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-21.043, -25.544],
                                                            [21.043, -25.544],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 10,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-17.7, -11.455],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.805, -8.721],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-20.429, -249.544],
                                                            [21.656, -250.294],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.52, "y": 1 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 25,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-17.7, -11.455],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.805, -8.721],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-20.429, -249.544],
                                                            [21.656, -250.294],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 35,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-12.426, 9.482],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.426, 9.482],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-21.043, -25.544],
                                                            [21.043, -25.544],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 50,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 4,
                    "ty": 4,
                    "nm": "Mail top 3",
                    "parent": 6,
                    "td": 1,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-0.001, -138.232, 0], "ix": 2 },
                        "a": { "a": 0, "k": [-0.001, -138.232, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.48, "y": 0 },
                                                "t": 2,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-12.426, 9.482],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.426, 9.482],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-21.043, -25.544],
                                                            [21.043, -25.544],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 10,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-17.7, -11.455],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.805, -8.721],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-20.429, -249.544],
                                                            [21.656, -250.294],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.52, "y": 1 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 25,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-17.7, -11.455],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.805, -8.721],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-20.429, -249.544],
                                                            [21.656, -250.294],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 35,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [-12.426, 9.482],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [12.426, 9.482],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-168.713, -138.232],
                                                            [-21.043, -25.544],
                                                            [21.043, -25.544],
                                                            [168.712, -138.231]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 50,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 5,
                    "ty": 4,
                    "nm": "Mail down",
                    "parent": 6,
                    "tt": 2,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [8.529, -6.357],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [-8.529, -6.357],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [168.658, 75.811],
                                                [14.375, -39.184],
                                                [-14.375, -39.184],
                                                [-168.661, 75.809]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 50,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 6,
                    "ty": 4,
                    "nm": "Mail base",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": [0.52], "y": [1] },
                                    "o": { "x": [0.48], "y": [0] },
                                    "t": 3.6,
                                    "s": [0]
                                },
                                {
                                    "i": { "x": [0.52], "y": [1] },
                                    "o": { "x": [0.48], "y": [0] },
                                    "t": 10,
                                    "s": [-13]
                                },
                                {
                                    "i": { "x": [0.52], "y": [1] },
                                    "o": { "x": [0.48], "y": [0] },
                                    "t": 14.8,
                                    "s": [8]
                                },
                                {
                                    "i": { "x": [0.52], "y": [1] },
                                    "o": { "x": [0.48], "y": [0] },
                                    "t": 21.199,
                                    "s": [-2]
                                },
                                { "t": 27.599609375, "s": [0] }
                            ],
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": 0.89, "y": 1 },
                                    "o": { "x": 0.167, "y": 0 },
                                    "t": 3,
                                    "s": [250, 293.765, 0],
                                    "to": [0, 4.117, 0],
                                    "ti": [0, -8.836, 0]
                                },
                                {
                                    "i": { "x": 0.89, "y": 1 },
                                    "o": { "x": 0.167, "y": 0 },
                                    "t": 21,
                                    "s": [250, 320, 0],
                                    "to": [0, 25.508, 0],
                                    "ti": [0, 4.372, 0]
                                },
                                { "t": 36, "s": [250, 293.765, 0] }
                            ],
                            "ix": 2
                        },
                        "a": { "a": 0, "k": [0, -31.235, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 9.275],
                                                [0, 0],
                                                [-9.275, 0],
                                                [0, 0],
                                                [0, -9.275],
                                                [0, 0],
                                                [9.275, 0]
                                            ],
                                            "o": [
                                                [-9.275, 0],
                                                [0, 0],
                                                [0, -9.275],
                                                [0, 0],
                                                [9.275, 0],
                                                [0, 0],
                                                [0, 9.275],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-157.52, 80.036],
                                                [-174.314, 63.243],
                                                [-174.314, -125.712],
                                                [-157.52, -142.506],
                                                [157.52, -142.506],
                                                [174.314, -125.712],
                                                [174.314, 63.243],
                                                [157.52, 80.036]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = comp('40- Message').layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 50,
                    "st": 0,
                    "bm": 0
                }
            ]
        }
    ],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width-Color Ctrl",
            "parent": 6,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 1,
            "nm": "mask",
            "parent": 1,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 68, 0], "ix": 2 },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "sw": 500,
            "sh": 500,
            "sc": "#ffffff",
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 0,
            "nm": "arrow",
            "parent": 1,
            "tt": 1,
            "refId": "comp_0",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 68, 0], "ix": 2 },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "w": 500,
            "h": 500,
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 0,
            "nm": "Arrow mask",
            "parent": 1,
            "td": 1,
            "refId": "comp_1",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 68, 0], "ix": 2 },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "w": 500,
            "h": 500,
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 0,
            "nm": "Mail",
            "parent": 1,
            "tt": 2,
            "refId": "comp_2",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 68, 0], "ix": 2 },
                "a": { "a": 0, "k": [250, 325, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "w": 500,
            "h": 650,
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 3,
            "nm": "Zero |  Stroke width-Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
